import * as React from 'react';
import * as I18n from 'i18n-js';

export function AffirmCartOptionText() {
  return (
    <>
      {I18n.t('discovery.cart.buyNowPayOverTime')}
      <p className="mb-0 size-90 opacity-60">
        {I18n.t('discovery.cart.makeMonthlyPayments')}
      </p>
    </>
  );
}
export default AffirmCartOptionText;



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/components/cart/affirm_cart_option_text.tsx